import postscribe from 'postscribe';
import PropTypes from 'prop-types';
import {useEffect} from 'react';
import {connect} from 'react-redux';
import {initClarusElementTracking} from '../../../v2/order-complete/element-click-event-tracking';
import {isMobile} from '../../../v2/selectors/DeviceSelectors';
import doMetric from '../../../v2/tracking/bigQueryMetricRecorder';
import Track from '../../../v2/utils/tracking';

import './Clarus.scss';

export function Clarus(props) {
  const handleClarusClose = (mobile) => {
    const clarusPopup = document.getElementById(`clarus-banner-pop-up${(mobile ? '-mobile' : '')}`);
    if (clarusPopup) {
      clarusPopup.classList.add('hide');
    }
  };
  
  const showClarusPopup = (mobile) => {
    const clarusPopup = document.getElementById(`clarus-banner-pop-up${(mobile ? '-mobile' : '')}`);
    if (clarusPopup) {
      clarusPopup.classList.remove('hide');
    }
  };
  
  const renderAd = () => {
    const {mobile} = props;
    setTimeout(() => {
      postscribe('#clarus-script-container-banner', '<script src="https://www.googletagservices.com/dcm/dcmads.js"></script>', {
        error: () => {
          handleClarusClose();
        },
      });
    }, 100);
    
    setTimeout(() => {
      showClarusPopup(mobile);
      postscribe(`#clarus-script-container-popup-${mobile ? 'mobile' : 'desktop'}`, '<script src="https://www.googletagservices.com/dcm/dcmads.js"></script>',
        {error: () => handleClarusClose()});
    }, 500);
  };
  
  useEffect(() => {
    initClarusElementTracking();
    props.shouldRender && renderAd();
    // Add External Listener to handle click anywhere on screen
    document.addEventListener('click', () => handleClarusClose(props.mobile));
    return () => {
      document.removeEventListener('click', () => handleClarusClose(props.mobile));
    };
  }, []);
  
  const getBannerSuffix = (guestBanner, mobile) => {
    if (guestBanner && !mobile) {
      return 'clarus-banner__guestBanner';
    }
    
    if (!guestBanner && !mobile) {
      return 'clarus-banner';
    }
    
    if (mobile) {
      return 'clarus-banner-mobile';
    }
  };
  
  const insertBanner = (mobile, id, guestBanner) => (
    <div className={getBannerSuffix(guestBanner, mobile)}>
      <ins
        className={`dcmads ${mobile ? 'bannerMobile' : 'banner'}`}
        data-dcm-placement={id}
        data-dcm-rendering-mode="script"
        data-dcm-https-only
        data-dcm-resettable-device-id=""
        data-dcm-app-id=""
      />
      <div id="clarus-script-container-banner" />
    </div>
  );
  
  useEffect(() => {
    if (props.shouldRender) {
      try {
        doMetric('Clarus', [{name: 'loaded', value: true}], [], 'impression');
      } catch (error) {
        Track.track(error);
      }
    }
  }, [props.shouldRender]);
  
  const insertPopUp = (mobile, id) => (
    <div id={`clarus-banner-pop-up${mobile ? '-mobile' : ''}`} className="hide">
      <ins
        className={`dcmads ${mobile ? 'popUpMobile' : 'popUp'}`}
        data-dcm-placement={id}
        data-dcm-rendering-mode="script"
        data-dcm-https-only
        data-dcm-resettable-device-id=""
        data-dcm-app-id=""
      />
      <div id={`clarus-script-container-popup-${mobile ? 'mobile' : 'desktop'}`} />
      <span className={`clarus-close${(mobile ? '-mobile' : '')}`} onClick={() => handleClarusClose(mobile)} />
    </div>
  );
  
  const {
    shouldRender, mobile, bannerId, popupId, guestBanner,
  } = props;
  
  if (!shouldRender) return null;
  
  return (
    <div className="unit size-1of1 last-unit clarus" data-cs-mask>
      <div className="clarus-banner-wrapper">
        {insertBanner(mobile, bannerId, guestBanner)}
        {insertPopUp(mobile, popupId)}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  const {start} = state;
  const clarusAdvertising = start.settings && start.settings.clarus_advertising;
  
  if (!clarusAdvertising) return {shouldRender: false};
  
  const mobile = isMobile(state);
  const country = start.order?.billingAddress?.countryCode || start.customer.location;
  const tag = clarusAdvertising[country.toLowerCase()];
  
  let bannerId;
  let popupId;
  
  if (tag) {
    bannerId = (!mobile ? tag.gdcPlacementBanner : tag.gdcPlacementBannerMobile);
    popupId = (!mobile ? tag.gdcPlacementPopUp : tag.gdcPlacementPopUpMobile);
  }
  
  return {
    bannerId,
    popupId,
    shouldRender: !!(bannerId || popupId),
    mobile,
  };
};

Clarus.propTypes = {
  bannerId: PropTypes.string,
  popupId: PropTypes.string,
  shouldRender: PropTypes.bool,
  mobile: PropTypes.bool,
  guestBanner: PropTypes.bool,
};

export default connect(
  mapStateToProps,
)(Clarus);
